import { render, staticRenderFns } from "./handouts.vue?vue&type=template&id=2cbf03d1&scoped=true"
import script from "./handouts.vue?vue&type=script&lang=js"
export * from "./handouts.vue?vue&type=script&lang=js"
import style0 from "./handouts.vue?vue&type=style&index=0&id=2cbf03d1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbf03d1",
  null
  
)

export default component.exports